import VehicleConditionReportWeb from 'src/@carketa/vehicle_dialog/components/views/vehicle_sales_packet/VehicleConditionReportWeb';

type VehicleConditionReportSectionProps = {
  vehicle: any;
  vehicle_inspections: any;
  inspectionId: string | null;
};

const VehicleConditionReportSection = ({
  vehicle,
  vehicle_inspections,
  inspectionId,
}: VehicleConditionReportSectionProps) => {
  return (
    <div id="vehicle-condition-report" className="mt-2 mb-5 w-full">
      <div style={{ overflowX: 'auto' }}>
        <VehicleConditionReportWeb
          vehicle={vehicle}
          vehicle_inspections={vehicle_inspections}
          inspectionId={inspectionId}
        />
      </div>
    </div>
  );
};

export default VehicleConditionReportSection;
